import React from "react";
import { Form, Label, Button } from "react-bootstrap";
import logoIcon from "../../assets/images/logo-full.svg";
import { useForm } from "react-hook-form";
import { useHistory, withRouter } from "react-router";
import {
  EmptyLocalStorage,
  ForgetPasswordApi,
} from "../../services/auth/auth.service";
import { toast } from "react-toastify";

function ForgotPassword() {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = async (data) => {
    const email = data.email;
    await ForgetPasswordApi(email)
      .then((data) => {
        if (data.success) {
          toast.success(data.message);
          history.push("/verify-code", { email: email });
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          EmptyLocalStorage();
          history.push("/");
        } else {
          return toast.error(error.response.data.message);
        }
      });
  };
  return (
    <div className={"text-center authLayout"}>
      <Form className={"form-signin"} onSubmit={handleSubmit(onSubmit)}>
        <a href="/">
          {/* <img
            className="img-fluid mb-4"
            src={logoIcon}
            alt="Imprint Logo"
            title="Imprint Logo"
          /> */}
          <img
            className="img-fluid mb-4 p-0"
            src={logoIcon}
            alt="Imprint Logo"
            title="Imprint Logo"
          />
        </a>
        <h1 className="h5 mb-3 font-weight-normal">Forgot Password</h1>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Control
            placeholder="Enter email"
            {...register("email", {
              required: {
                value: "required",
                message: "Email is required",
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Invalid email",
              },
              maxLength: {
                value: 255,
                message: "Maximum length is 255",
              },
            })}
            type="text"
          />
          {errors.email && (
            <span className={"validation-error pr-5"} role="alert">
              {errors.email.message}
            </span>
          )}
        </Form.Group>
        <div className="d-grid gap-2">
          <Button
            variant="primary"
            size="lg"
            type="submit"
            className={"btn-green-theme"}
          >
            Request Verification Code
          </Button>
        </div>
        <p className="mt-5 mb-3 text-muted">
          &copy; All rights reserved by Tekrevol 2023
        </p>
      </Form>
    </div>
  );
}

export default withRouter(ForgotPassword);
